import React from "react";
import "./FormInput.css";

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helpText?: string;
  variant?: "default" | "large";
}

const FormInput: React.FC<FormInputProps> = ({
  label,
  error,
  helpText,
  variant = "default",
  className = "",
  id,
  ...props
}) => {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;
  const baseClass = "form-input";
  const variantClass = `form-input-${variant}`;
  const errorClass = error ? "form-input-error" : "";

  const classes = [baseClass, variantClass, errorClass, className].filter(Boolean).join(" ");

  return (
    <div data-section="form-input-root" className="form-group">
      {label && (
        <label htmlFor={inputId} className="form-label">
          {label}
        </label>
      )}
      <input id={inputId} className={classes} {...props} />
      {helpText && !error && <p className="form-help-text">{helpText}</p>}
      {error && <p className="form-error-text">{error}</p>}
    </div>
  );
};

export default FormInput;
